import { VideoSegmentItem } from "./VideoSegmentItem";

/**
 * Handles video segments for the app
 */
export class VideoSegmentManager {
    /**
     * Holds all video segments, this will get filled as the game registers items
     */
    public items: VideoSegmentItem[] = [];

    /**
     * Registers a new video segment. This needs to be called for every class that derives from VideoSegmentItem
     * @param item The segment
     */
    public registerItem(item: VideoSegmentItem) {
        this.items.push(item);
    }
}